import Button from 'components/Button/Button';
import SubmitButton from 'components/Form/SubmitButton/SubmitButton';
import { useNavigate } from 'react-router-dom';
import Flex from 'style-utils/components/Flex';
import go_back_arrow from 'assets/icons/form/go_back_arrow.svg';
import Icon from 'components/Icon/Icon';

type RegistrationFormFooterProps = {
  goBackUrl?: string;
  isDisabled?: boolean;
};
const RegistrationFormFooter = (props: RegistrationFormFooterProps) => {
  const { goBackUrl, isDisabled } = props;
  const navigate = useNavigate();

  const handleGoBackButtonClick = () => {
    navigate(goBackUrl as string);
  };

  return (
    <Flex mt="2.6rem">
      {goBackUrl && (
        <Button
          pl={'0'}
          onClick={handleGoBackButtonClick}
          variant="thertiary"
          typographyVariant="uBold16"
          i18nKey="goBackButtonText"
          beforeComponent={<Icon iconSrc={go_back_arrow} mr=".8rem" />}
        />
      )}
      <SubmitButton
        ml="auto"
        i18nKey={'submitButtonText'}
        disabled={isDisabled}
      />
    </Flex>
  );
};

export default RegistrationFormFooter;
